// infrastructure/Common/authEvents.ts
// A tiny event bus to decouple infra (API wrappers) from the app/store.

export type AuthEvent = 'sessionExpired';
type Handler = () => void;

class AuthEventBus {
  private listeners: Record<AuthEvent, Set<Handler>> = {
    sessionExpired: new Set(),
  };

  on(event: AuthEvent, handler: Handler): () => void {
    this.listeners[event].add(handler);
    return () => this.off(event, handler);
  }

  off(event: AuthEvent, handler: Handler): void {
    this.listeners[event].delete(handler);
  }

  emit(event: AuthEvent): void {
    // copy to avoid mutation during iteration
    for (const h of [...this.listeners[event]]) {
      try {
        h();
      } catch {
        // swallow to keep bus resilient
      }
    }
  }
}

export const authEvents = new AuthEventBus();
